import React from "react";

const Suitcase = ({ height = "14", width = "14" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 7H7.0075"
        stroke="#6570FC"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33268 3.49935V2.33268C9.33268 2.02326 9.20977 1.72652 8.99097 1.50772C8.77218 1.28893 8.47543 1.16602 8.16602 1.16602H5.83268C5.52326 1.16602 5.22652 1.28893 5.00772 1.50772C4.78893 1.72652 4.66602 2.02326 4.66602 2.33268V3.49935"
        stroke="#6570FC"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8327 7.58398C11.1018 8.72672 9.07342 9.33591 6.99935 9.33591C4.92528 9.33591 2.89689 8.72672 1.16602 7.58398"
        stroke="#6570FC"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.666 3.5H2.33268C1.68835 3.5 1.16602 4.02233 1.16602 4.66667V10.5C1.16602 11.1443 1.68835 11.6667 2.33268 11.6667H11.666C12.3103 11.6667 12.8327 11.1443 12.8327 10.5V4.66667C12.8327 4.02233 12.3103 3.5 11.666 3.5Z"
        stroke="#6570FC"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Suitcase;
